export default "<div class=\"o-bunch{% if class %} {{ class }}{% endif %}\">\n  {% block content %}{% endblock %}\n</div>\n";